// import React, {useState} from 'react'
import '../Pages/style.css'
import { RiCloseCircleFill } from "react-icons/ri";
import ErrorIcon from '../assets/error.svg';

const Error = ({closeOverlay, message}) => {
    // const [close, setClose] = useState(false)
    const handleClose = () =>{
        // setClose(!close)
        closeOverlay(true)
    }

  return (
    <div className='errorContainer'>
        <div className='errorSubContain'>
            <div className='ClsiconContain'><RiCloseCircleFill onClick={handleClose} id='closeIcon'/></div>
            <div className='iconContainer'><img src={ErrorIcon} alt="iconImage"  id='errorIcon'/></div>
            <span id="errorInfo">{message}</span>
        </div>
    </div>
  )
}

export default Error
